<template>
    <div class="vx-row">
        <div class="w-full vx-col">
            <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="mb-8 user-list-filters"
                :collapse-action="true">
                <div class="vx-row">
                    <div class="w-full vx-col md:w-1/3 sm:w-1/2">
                        <label class="text-sm opacity-100 text-bold">Type</label>
                        <v-select :clearable="false" placeholder="" v-model="filters['type']"
                            :options="['Skill', 'Qualification']" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                        </v-select>
                    </div>
                </div>
                <div class="mt-5 vx-row">
                    <div class="w-full ml-auto vx-col">
                        <vs-button class="float-right mr-4" size="small" color="danger" type="border"
                            icon-pack="feather" v-on:click="filters = {}">CLEAR</vs-button>
                    </div>
                </div>
            </vx-card>
            <vx-card :title="'Skill & Qualification Categories'" class="">
                <template slot="actions">
                    <vs-button v-can="'edit-ccp-items-setting'" @click.stop="onClickAdd" icon-pack="feather"
                        icon="icon-plus" class="mr-4" color="primary" type="filled">create</vs-button>
                </template>
                <div id="categories-table" class="vx-row">
                    <div class="w-full vx-col">

                        <vs-table stripe sort class="mt-8" :data="categories">
                            <template slot="thead">
                                <vs-th width="25%">Name</vs-th>
                                <vs-th width="15%">Type</vs-th>
                                <vs-th width="40%">Description</vs-th>
                                <vs-th width="10%">Status</vs-th>
                                <vs-th width="10%">ACTION</vs-th>
                            </template>

                            <template slot-scope="{data}">
                                <vs-tr class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data">

                                    <vs-td :data="data[indextr].name">
                                        {{ data[indextr].name }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].type">
                                        {{ data[indextr].type }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].description">
                                        <vx-read-more :length="100" :text="data[indextr].description" />
                                    </vs-td>

                                    <vs-td :data="data[indextr].is_active">
                                        <vs-chip transparent :color="data[indextr].is_active ?  'primary' : 'danger'">
                                            {{ data[indextr].is_active ?  '✔ Active' : '⛔ Inactive' }}
                                        </vs-chip>
                                    </vs-td>

                                    <vs-td :data="data[indextr].name">
                                        <div class="justify-start vx-row" v-can="'edit-ccp-items-setting'">
                                            <vx-tooltip text="View/Update" position="left">
                                                <vs-button @click.stop="onClickUpdate(data[indextr].id)" class="ml-3"
                                                    size="small" color="warning" type="border" icon-pack="feather"
                                                    icon="icon-edit-2"></vs-button>
                                            </vx-tooltip>
                                        </div>
                                    </vs-td>

                                </vs-tr>
                            </template>

                        </vs-table>
                        <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20"
                            :max-items="perPage" description-body="Rows per page" description-connector="of"
                            description-title="Records" description :description-items="descriptionItems"
                            :total="(meta.last_page) ? meta.last_page : 0" v-model="page" class="p-5">
                        </vs-pagination>


                    </div>
                </div>
            </vx-card>
        </div>
        <AddNewSkillQulificationCategoryPopUp ref="addNewSkillQulificationCategoryPopUp"/>
    </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory';
import AddNewSkillQulificationCategoryPopUp from '@/components/popups/settings/skill-qualification/AddNewSkillQulificationCategoryPopUp.vue'

import vSelect from 'vue-select'
import Filter from '@/mixins/filter';
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

import { defaultPagination, perPageList } from "@/constants/config";

const SkillQualificationRepository = RepositoryFactory.get('skills');

export default {
    name: "SkillQualificationCategories",
    data() {
        return {
            categories: [],
            filters: {
                type: ''
            },
            page: 1,
            total: 0,
            meta: {},
            sort: '',
            perPage: defaultPagination,
            descriptionItems: perPageList,
        }
    },
    components: {
        AddNewSkillQulificationCategoryPopUp,
        'v-select': vSelect,
    },
    methods: {
        async refreshData() {
            await this.fetchCategories()
        },
        async fetchCategories() {
            await this.$vs.loading({
                container: '#categories-table',
                scale: 0.45
            })
            const { data } = await SkillQualificationRepository.getListOfSkillQualificationCategories(this.page, this.filterQuery, this.perPage, this.sort)
            this.categories = data.data
            this.meta = data.meta
            this.$vs.loading.close('#categories-table > .con-vs-loading')
        },
        async onClickAdd() {
            await this.$refs.addNewSkillQulificationCategoryPopUp.openPopup()
        },
        async onClickUpdate(id) {
            await this.$refs.addNewSkillQulificationCategoryPopUp.openPopup(id)
        },
        filterQueryUpdate() {
            this.fetchCategories()
        },
        handleChangePage(page) {
            this.page = page;
            this.fetchCategories()
        },
        handleSort(key, active) {
            if (key) {
                active = (active === 'desc') ? "-" : '';
                this.sort = active + key;
                this.fetchCategories()
            }
        },
        changePage(index) {
            this.perPage = this.descriptionItems[index]
        },
    },
    async mounted() {
        
    },
    mixins: [Filter, SuccessMessage, ErrorMessages],
    watch: {
        page() {
            this.fetchCategories()
        },
        perPage() {
            this.fetchCategories()
        }
    }
}
</script>

<style scoped></style>